/* Kandes lead capture — drawers (quote/spec), CAD gate, gateway POST, GA4 events.
   Self-contained vanilla JS; no dependency on theme.js internals.
   Gateway contract: gateway/deploy.md. Events: quote_request, cad_access_request, spec_sheet_request. */
(function () {
  'use strict';

  // Several sections include this asset (lead drawers overlay, product tabs, CAD
  // gate, downloads) and duplicate classic <script> tags each execute, so on pages
  // where two of them render the document-level submit listener used to register
  // twice — one click, two gateway POSTs (9 Jul 2026: duplicate Pipedrive deals
  // 1723/1724). Run once per page, no matter how many sections load the file.
  if (window.__kandesLeadLoaded) return;
  window.__kandesLeadLoaded = true;

  var CAD_STORAGE_KEY = 'kandesCadAccess';
  var CAD_EXPIRY_DAYS = 365;

  function gatewayRoot() {
    var el = document.querySelector('[data-kandes-gateway]');
    return el ? (el.getAttribute('data-kandes-gateway') || '').replace(/\/+$/, '') : '';
  }

  function pageLocale() {
    var el = document.querySelector('[data-kandes-locale]');
    var loc = (el && el.getAttribute('data-kandes-locale')) ||
      (document.documentElement.lang || 'en').split('-')[0];
    return ['en', 'de', 'fr', 'it', 'es'].indexOf(loc) >= 0 ? loc : 'en';
  }

  function trackEvent(name) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, { locale: pageLocale() });
      }
    } catch (e) { /* analytics must never break the form */ }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name });
      if (typeof window.gtag === 'function') { window.gtag('event', name); }
    } catch (e) { /* ditto */ }
  }

  /* ---------- Open-download tracking (decision change #1, 7 Jul 2026) ----------
     Direct PDF links (Downloads & Certifications page + product-page rows) fire
     a GA4 `file_download` micro-event — standard enhanced-measurement name,
     deliberately NOT a key event. Same triple mechanism as trackEvent. */

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-kandes-download]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var file = link.getAttribute('data-file-name') ||
      href.split('/').pop().split('?')[0];
    var params = {
      file_name: file,
      file_extension: file.indexOf('.') >= 0 ? file.split('.').pop().toLowerCase() : '',
      link_url: href,
      locale: pageLocale()
    };
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('file_download', params);
      }
    } catch (err) { /* analytics must never block the download */ }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'file_download',
        file_name: params.file_name,
        file_extension: params.file_extension,
        link_url: params.link_url,
        locale: params.locale
      });
      if (typeof window.gtag === 'function') { window.gtag('event', 'file_download', params); }
    } catch (err) { /* ditto */ }
  });

  /* ---------- Drawers ---------- */

  function openDrawer(id, trigger) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    var form = drawer.querySelector('form[data-kandes-form]');
    if (form && trigger) {
      var title = trigger.getAttribute('data-product-title') || '';
      var handle = trigger.getAttribute('data-product-handle') || '';
      var isQuote = form.getAttribute('data-kandes-form') === 'quote';
      var productField = form.querySelector('input[name="product"]');
      var freetextWrap = form.querySelector('[data-kandes-product-freetext]');
      // Quote drawer (9 Jul UX round): the product field is VISIBLE and prefilled with the
      // model + SKU — the part of the title after the last "|" (titles read
      // "GYPSUM 3D WALL PANEL | SOAP 0046"). The customer can edit it; collectPayload
      // sends the freetext as `product` when the hidden field is empty, so on the quote
      // form the hidden field stays empty and the visible value is what reaches Pipedrive.
      var model = title ? title.split('|').pop().trim() : '';
      if (productField) productField.value = (title && !isQuote) ? (handle + ' — ' + title) : '';
      if (freetextWrap) {
        freetextWrap.hidden = !isQuote;
        var freetext = freetextWrap.querySelector('input[name="product_freetext"]');
        if (freetext && isQuote) freetext.value = model;
      }
      var variantField = form.querySelector('input[name="variant"]');
      if (variantField) {
        var sel = document.querySelector('script[data-selected-variant]');
        if (sel && title) {
          try { variantField.value = (JSON.parse(sel.textContent) || {}).title || ''; }
          catch (e) { variantField.value = ''; }
        } else { variantField.value = ''; }
      }
    }
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var first = drawer.querySelector('input[type="text"], input[type="email"]');
    if (first) setTimeout(function () { first.focus(); }, 50);
  }

  function closeDrawer(drawer) {
    drawer.hidden = true;
    document.documentElement.style.overflow = '';
    // If the thank-you panel was showing, put the form back for the next visit.
    var thanks = drawer.querySelector('[data-kandes-thankyou]');
    if (thanks && !thanks.hidden) {
      thanks.hidden = true;
      var form = drawer.querySelector('form[data-kandes-form]');
      if (form) form.hidden = false;
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-kandes-open]');
    if (opener) {
      e.preventDefault();
      var kind = opener.getAttribute('data-kandes-open');
      openDrawer(kind === 'quote' ? 'KandesQuoteDrawer' : 'KandesSpecDrawer', opener);
      return;
    }
    var closer = e.target.closest('[data-kandes-close]');
    if (closer) {
      var drawer = closer.closest('.kandes-drawer');
      if (drawer) closeDrawer(drawer);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.kandes-drawer:not([hidden])').forEach(closeDrawer);
  });

  /* ---------- CH note on country selects ---------- */

  function syncCountryUI(sel) {
    var note = sel.parentElement.querySelector('[data-kandes-ch-note]');
    if (note) note.hidden = sel.value !== 'CH';
    // Swiss spec leads: reveal + require a postal code so the gateway can route
    // Hochwert-region leads to the distributor and keep the rest on the Kandes
    // follow-up. On kandes.ch the country defaults to CH, so the postal field is
    // visible from the start; the input is disabled while hidden.
    var form = sel.closest('form');
    var wrap = form && form.querySelector('[data-kandes-ch-postal]');
    if (wrap) {
      var input = wrap.querySelector('input[name="postal_code"]');
      var isCH = sel.value === 'CH';
      wrap.hidden = !isCH;
      if (input) {
        input.disabled = !isCH;
        input.required = isCH;
        if (!isCH) input.value = '';
      }
    }
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-kandes-country]');
    if (sel) syncCountryUI(sel);
  });

  /* ---------- Form submit ---------- */

  function setInvalid(form, names) {
    form.querySelectorAll('.kandes-field--invalid').forEach(function (f) {
      f.classList.remove('kandes-field--invalid');
    });
    (names || []).forEach(function (n) {
      var input = form.querySelector('[name="' + n + '"]');
      if (input) {
        var field = input.closest('.kandes-field');
        if (field) field.classList.add('kandes-field--invalid');
      }
    });
  }

  function collectPayload(form) {
    var payload = { locale: pageLocale(), source_url: window.location.href.split('#')[0] };
    new FormData(form).forEach(function (value, key) {
      if (key === 'consent') return;
      payload[key] = String(value).trim();
    });
    payload.consent = !!form.querySelector('input[name="consent"]').checked;
    if (payload.product_freetext) {
      if (!payload.product) payload.product = payload.product_freetext;
      delete payload.product_freetext;
    }
    // Buying-stage picker (staged worker patch NOT deployed): append the chosen
    // label to the free-text message — always accepted by the gateway — and do NOT
    // send a separate field. After the worker's Buying Stage patch deploys, add
    // project_stage: <value> here as well (see conversion-microcopy staged doc).
    if ('kandes_stage' in payload) {
      var stageSel = form.querySelector('select[name="kandes_stage"]');
      if (payload.kandes_stage && stageSel) {
        var opt = stageSel.options[stageSel.selectedIndex];
        var stageLabel = (opt && opt.textContent || payload.kandes_stage).trim();
        payload.message = (payload.message ? payload.message + '\n' : '') + 'Project stage: ' + stageLabel;
      }
      delete payload.kandes_stage;
    }
    // Honeypot: DOM fields renamed kandes_x1 (9 Jul 2026) — Chrome autofilled the old
    // name="website" with saved URLs, silently dropping real leads (same fix the wall
    // planner got on 8 Jul). Payload key stays "website" (gateway contract).
    if ('kandes_x1' in payload) {
      payload.website = payload.kandes_x1;
      delete payload.kandes_x1;
    }
    return payload;
  }

  function submitLead(form, onDone) {
    var root = gatewayRoot();
    var errorEl = form.querySelector('[data-kandes-error]') ||
      (form.parentElement && form.parentElement.querySelector('[data-kandes-error]'));
    var btn = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-kandes-submit-label]');

    if (!form.checkValidity()) { form.reportValidity(); return; }
    // In-flight latch: btn.disabled stops the NEXT click but not a second listener
    // handling the SAME submit event, so gate on the form itself as well.
    if (form.getAttribute('data-kandes-inflight') === '1') return;
    form.setAttribute('data-kandes-inflight', '1');
    if (errorEl) errorEl.hidden = true;
    if (btn) btn.disabled = true;
    if (label) { label.setAttribute('data-idle-label', label.textContent); label.textContent = label.getAttribute('data-sending-label') || '…'; }

    function fail() {
      form.removeAttribute('data-kandes-inflight');
      if (btn) btn.disabled = false;
      if (label) label.textContent = label.getAttribute('data-idle-label');
      if (errorEl) errorEl.hidden = false;
    }

    if (!root) { fail(); return; }

    fetch(root + '/lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(collectPayload(form))
    }).then(function (resp) {
      return resp.json().then(function (body) { return { status: resp.status, body: body }; });
    }).then(function (r) {
      if (r.body && r.body.ok) {
        form.removeAttribute('data-kandes-inflight');
        onDone(r.body);
      } else if (r.status === 400 && r.body && r.body.fields) {
        setInvalid(form, r.body.fields);
        fail();
      } else {
        fail();
      }
    }).catch(fail);
  }

  /* ---------- Quote drawer → wall planner handoff (Yulia, 9 Jul 2026) ----------
     The "use our wall planner" link under the m² field carries the customer's
     already-typed fields to the planner (sessionStorage; kandes-wall-planner.js
     prefills its own form) and preselects the product's model via ?model=<sku>. */

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-kandes-to-planner]');
    if (!link) return;
    e.preventDefault();
    var form = link.closest('form[data-kandes-form]');
    var prefill = {};
    if (form) {
      ['name', 'email', 'company', 'phone', 'country', 'postal_code',
       'project_type', 'timeline', 'message', 'product_freetext'].forEach(function (n) {
        var input = form.querySelector('[name="' + n + '"]');
        if (input && input.value) prefill[n === 'product_freetext' ? 'product' : n] = String(input.value).trim();
      });
    }
    try { window.sessionStorage.setItem('kandesPlannerPrefill', JSON.stringify(prefill)); }
    catch (err) { /* private mode — still navigate, just without prefill */ }
    var sku = '';
    var m = (prefill.product || '').match(/\b0\d{3}\b/g);
    if (m) sku = m[m.length - 1];
    window.location.href = (link.getAttribute('href') || '/pages/wall-planner') +
      (sku ? '?model=' + encodeURIComponent(sku) : '');
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-kandes-form]');
    if (!form) return;
    e.preventDefault();
    var kind = form.getAttribute('data-kandes-form');

    submitLead(form, function (body) {
      if (kind === 'quote') {
        trackEvent('quote_request');
        finishDrawerSubmit(form, 'quote');
      } else if (kind === 'spec') {
        trackEvent('spec_sheet_request');
        finishDrawerSubmit(form, 'spec');
      } else if (kind === 'cad') {
        trackEvent('cad_access_request');
        grantCadAccess(true);
      }
    });
  });

  /* ---------- Post-submit UX (Yulia, 9 Jul 2026) ----------
     On success: stop the sending state, reset + close the drawer, float a small toast
     (Wall Planner style: faint yellow, bordered, bold first line) that the customer can
     close or that fades by itself after 4s. Failure keeps the drawer open with the
     "please email info@kandes.ch" line and re-enables the button (submitLead's fail()).
     The Wall Planner page's own quote form is untouched — it is not a [data-kandes-form]. */

  var TOAST_COPY = {
    quote: {
      lead: 'Thanks — you’ll have your quote within one business day.',
      rest: 'Please also check your spam folder, just in case it lands there.'
    },
    spec: {
      lead: 'Thank you.',
      rest: 'One of our team members will share the requested documentation with you shortly. Please also check your spam folder, just in case it lands there.'
    }
  };

  function showToast(kind) {
    var copy = TOAST_COPY[kind];
    if (!copy) return;
    var old = document.querySelector('.kandes-toast');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var toast = document.createElement('div');
    toast.className = 'kandes-toast';
    toast.setAttribute('role', 'status');
    var lead = document.createElement('p');
    lead.className = 'kandes-toast__lead';
    lead.textContent = copy.lead;
    var rest = document.createElement('p');
    rest.textContent = copy.rest;
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'kandes-toast__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&times;';
    toast.appendChild(close);
    toast.appendChild(lead);
    toast.appendChild(rest);
    document.body.appendChild(toast);

    var timer = setTimeout(dismiss, 4000);
    close.addEventListener('click', dismiss);
    function dismiss() {
      clearTimeout(timer);
      toast.classList.add('kandes-toast--out');
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 450);
    }
  }

  function finishDrawerSubmit(form, kind) {
    var btn = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-kandes-submit-label]');
    if (label && label.getAttribute('data-idle-label')) {
      label.textContent = label.getAttribute('data-idle-label');
    }
    form.reset();
    // form.reset() returns Country to its default (CH on kandes.ch) without firing
    // `change`, so re-sync the CH note + postal field state by hand.
    form.querySelectorAll('select[data-kandes-country]').forEach(syncCountryUI);
    if (btn) btn.disabled = false;
    var drawer = form.closest('.kandes-drawer');
    // Quote drawer (10 Jul microcopy): stay open and show the in-drawer thank-you
    // panel with next steps; the drawer close handler restores the form afterwards.
    var thanks = drawer && drawer.querySelector('[data-kandes-thankyou]');
    if (kind === 'quote' && thanks) {
      form.hidden = true;
      thanks.hidden = false;
      return;
    }
    if (drawer) closeDrawer(drawer);
    showToast(kind);
  }

  /* ---------- CAD gate (handoff §6) ---------- */

  function cadAccessValid() {
    try {
      var v = window.localStorage.getItem(CAD_STORAGE_KEY);
      if (!v || v.indexOf('granted:') !== 0) return false;
      var granted = new Date(v.slice(8));
      return !isNaN(granted) && (Date.now() - granted.getTime()) < CAD_EXPIRY_DAYS * 864e5;
    } catch (e) { return false; }
  }

  function grantCadAccess(fromSubmit) {
    var gate = document.getElementById('KandesCadGate');
    var target = document.getElementById('KandesCadFiles');
    if (!target) return;
    if (fromSubmit) {
      try { window.localStorage.setItem(CAD_STORAGE_KEY, 'granted:' + new Date().toISOString()); }
      catch (e) { /* private mode — still reveal this visit */ }
    }
    // Downloads live in the alternate view templates/page.cad-files.json —
    // absent from this page's HTML so view-source cannot leak them.
    fetch(window.location.pathname + '?view=cad-files')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var main = doc.getElementById('MainContent') || doc.querySelector('main');
        if (!main) throw new Error('no MainContent in cad-files view');
        target.innerHTML = main.innerHTML;
        if (gate) gate.hidden = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function () {
        var err = gate && gate.querySelector('[data-kandes-error]');
        if (err) err.hidden = false;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('KandesCadGate') && cadAccessValid()) {
      grantCadAccess(false);
    }
  });
})();
